import * as React from "react";

type Props = {
    title: string
    id?: string
    className?: string
}

const SidePanel : React.FC<Props> = ({children, title, id, className}) => {
    const _id = id ?? '';
    const _className = className ?? '';
    return (
        <div className={"side-panel " + _className} id={_id}>
            <div className={"title"}>{title}</div>
            <div className={"contents"}>
                {children}
            </div>
        </div>
    );
}

export default SidePanel;
